import { QUICKBOOKSDETAILS } from '../actionTypes';

export const fetchQuickBookDetails = (action) => ({
  type: QUICKBOOKSDETAILS.FETCH,
  payload: action.payload,
});
